import {Injectable, InjectionToken} from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class Environment {
    /**
     * Environment Name
     */
    name: string;
    /**
     * Namespace
     */
    namespace: string;
    
    /**
     * Backend URL that is behind ambassador
     */
    backendUrl: string;
    /**
     * Front end URL
     */
    frontendUrl: string;
    /**
     * Backend URL that is NOT behind ambassador
     */
    backendUrlOutsideLoadBalancer: string;
    /**
     * If true, the app is configured to be in the integrated state
     */
    isIntegratedState: boolean;
    /**
     * Front end version
     */
    frontEndVersion: string;
    /**
     * Front end branch
     */
    frontEndBranch: string;
    /**
     * Timestamp
     */
    timestamp: number;

    /**
     * If True, the application is running in local mode
     */
    isLocal(): boolean {
        return this.name === 'local';
    }

    /**
     * If True, the app is configured to run in Production mode
     */
    isProduction(): boolean {
        return this.name === 'production';
    }
}

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
